import ThemeFirstPage from './../themeFirstPage/themeFirstPage.js';
import background_img from "./../../static/images/background_1.webp";
import { useSelector, useDispatch } from "react-redux";
import AppRoutes from "./../../routes.js";
import { actionTypes } from './../../store';
import axios from "axios";
import React, { useEffect} from "react";

export default function Finish(){
    const data = useSelector((state) => state.data);
    const status = useSelector((state) => state.status);
    const errors = useSelector((state) => state.errors);
    const dispatch = useDispatch();

    //Salva no redux os dados toda vez que eles são modificados
    async function sendError(){
        try {
            const header = {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${data.token}`
            };
            const jsonData = JSON.stringify(data);
            const response = await axios.post(`${AppRoutes.backend}send_error`, jsonData, { headers: header });
        } catch (error) {
            console.error(error);
            dispatch({type:actionTypes.set_errors, payload:error.toString()})
        }
    }

    //Muda o status no bitrix
    async function updateBitrix(){
        try {
            const header = {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${data.token}`
            };
            const jsonData = JSON.stringify(data);
            const response = await axios.post(`${AppRoutes.backend}update_bitrix`, jsonData, { headers: header });
        } catch (error) {
            console.error(error);
            dispatch({type:actionTypes.set_errors, payload:error.toString()})
        }
    }
    useEffect(()=>{
        console.log(status)
        if (status !== 'success' || data ){
            sendError();
        }
        if (status == 'success'){
            updateBitrix();
        }
    },[status,data])
    return(
        <div className="finish">
            <ThemeFirstPage>
                {status === 'success'?
                    (<span className="title-2">Formulário Assinado com sucesso!</span>):
                    (<span className="title-2 text-center">
                        <p>Ocorreu um erro inesperado ao processar seu formulário!</p>
                        <p>Tente novamente, caso o erro persista entre em contato conosco.</p>
                        <p>{errors}</p>
                    </span>)
                }
            </ThemeFirstPage>
        </div>
    )

}